module.exports = __webpack_public_path__ + "img/34.470d943b.png";